import { addDays, isSameWeek } from 'date-fns'

import { useSharedDates } from '@contexts/sharedDates'
import { useDate } from '@hooks/dates'

export function useStartDateField() {
  const { selectedDate } = useSharedDates()
  const { getWeekRange } = useDate()

  const { weekStart } = getWeekRange(selectedDate)

  const { weekStart: pullAheadStartDate, weekEnd: pullAheadEndDate } =
    getWeekRange(new Date())

  function getCurrentTaskRange() {
    const maxDate = addDays(weekStart, 21)

    return { minDate: weekStart, maxDate }
  }

  function getFutureTaskRange() {
    return { minDate: pullAheadStartDate, maxDate: pullAheadEndDate }
  }

  function getStartDateRange() {
    const { maxDate, minDate } = isSameWeek(selectedDate, new Date())
      ? getFutureTaskRange()
      : getCurrentTaskRange()

    return { maxDate, minDate }
  }

  return { getStartDateRange, getCurrentTaskRange, getFutureTaskRange }
}
